var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommandCloudIcon = function SvgCommandCloudIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#command-cloud-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#command-cloud-icon_svg__b)",
    d: "M159 95.603c-.003 8.761-3.605 16.721-9.482 22.631-7.095 7.136-19.762 4.215-23.081-5.071l-17.028-47.645a36.3 36.3 0 0 1 14.698-3.072c19.293.011 34.926 14.87 34.893 33.157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#command-cloud-icon_svg__c)",
    d: "m71.05 119.642-.501-1.405c5.341-6.681-1.015-33.545-5.23-36.588-3.533-2.553-7.684-4.274-12.082-4.995l.006.071c-1.521-.253-3.07-.43-4.663-.433-15.231-.005-27.587 11.68-27.615 26.088-.026 14.452 12.306 26.157 27.56 26.183l25.721.024 9.885.016c-5.907-.052-11.182-3.638-13.08-8.961"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#command-cloud-icon_svg__d)",
    d: "M149.271 118.469c-4.68 4.61-10.751 7.941-17.583 9.376a35 35 0 0 1-7.684.818l-46.523-.059c-5.953-.01-11.27-3.617-13.17-8.963L51.723 84.466a25 25 0 0 1-.915-3.13C47.353 66.582 56.615 51.4 72.594 47.257c15.71-4.102 31.98 4.78 37.209 19.39l1.051 2.895 15.649 43.779c3.352 9.073 15.68 11.945 22.768 5.147z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#command-cloud-icon_svg__e)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.325,
    height: 45.325,
    x: 113.671,
    y: 89.518,
    fill: "url(#command-cloud-icon_svg__f)",
    fillOpacity: 0.4,
    rx: 9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.875,
    height: 44.875,
    x: 113.896,
    y: 89.743,
    stroke: "#B2D5F6",
    strokeWidth: 0.45,
    rx: 8.775
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m137.736 108.191 7.157 7.908h-7.157v3.385h10.222l1.872-3.385-12.094-13.361zM133.77 104.036l-10.92 12.063 1.872 3.385h10.222v-3.385h-7.159l7.159-7.908v-5.453z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "command-cloud-icon_svg__b",
    x1: 88.725,
    x2: 167.315,
    y1: 40.033,
    y2: 105.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D72F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "command-cloud-icon_svg__c",
    x1: -5.38,
    x2: 63.38,
    y1: 56.675,
    y2: 139.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D72F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "command-cloud-icon_svg__d",
    x1: 8.72,
    x2: 117.106,
    y1: 15.351,
    y2: 145.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D72F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "command-cloud-icon_svg__f",
    x1: 94.766,
    x2: 155.405,
    y1: 72.521,
    y2: 133.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D72F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "command-cloud-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.965 46.254H159v82.409H20.965z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "command-cloud-icon_svg__e",
    width: 72.325,
    height: 72.325,
    x: 100.171,
    y: 76.018,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_21556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_200_21556",
    result: "shape"
  })))));
};
export { SvgCommandCloudIcon as ReactComponent };
export default "data:image/svg+xml;base64,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";